import { useState } from "react";
import { toast } from "sonner";
import { useApi, useResource } from "@/lib/api";
import { PageHeader, Panel, StatusPill, Loading, ErrorNote } from "@/components/kit";

const input = "w-full rounded-sm border border-[var(--cc-line)] bg-white px-3 py-2 text-sm outline-none focus:border-[var(--cc-navy)]";

const NewTask = ({ onDone }) => {
  const call = useApi();
  const [f, setF] = useState({ title: "", category: "development", assigned_to: "CC-DEV-001" });
  const submit = async (e) => {
    e.preventDefault();
    try { await call("/tasks", { method: "POST", body: f }); toast.success("Task recorded"); setF({ ...f, title: "" }); onDone(); }
    catch (err) { toast.error(err.message); }
  };
  return (
    <form onSubmit={submit} className="grid gap-3 md:grid-cols-[1fr_160px_160px_auto]" data-testid="new-task-form">
      <input data-testid="task-title-input" className={input} placeholder="Task title" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} />
      <select data-testid="task-category-select" className={input} value={f.category} onChange={(e) => setF({ ...f, category: e.target.value })}>
        <option value="development">development</option><option value="qa">qa</option><option value="release">release</option>
      </select>
      <input data-testid="task-assignee-input" className={input} value={f.assigned_to} onChange={(e) => setF({ ...f, assigned_to: e.target.value })} />
      <button data-testid="task-submit-button" className="rounded-sm bg-[var(--cc-navy)] px-5 py-2 text-sm text-white transition-colors hover:bg-[var(--cc-signal)] hover:text-[var(--cc-navy)]">Record task</button>
    </form>
  );
};

export const TaskList = ({ tasks }) => (
  <div className="divide-y divide-[var(--cc-line)]">
    {tasks.map((t) => (
      <div key={t.id} className="grid gap-2 py-4 md:grid-cols-[110px_1fr_auto] md:items-start" data-testid={`task-row-${t.id}`}>
        <span className="font-mono text-xs text-[var(--cc-muted)]">{t.id}</span>
        <div>
          <p className="font-medium text-[var(--cc-navy)]">{t.title}</p>
          <p className="mt-0.5 text-xs text-[var(--cc-muted)]">{t.category} · assigned {t.assigned_to} · {t.authorization}</p>
          {t.evidence?.length > 0 && <ul className="mt-2 space-y-0.5 text-xs text-[var(--cc-ink)]">{t.evidence.map((e, i) => <li key={i}>▸ {e}</li>)}</ul>}
        </div>
        <StatusPill status={t.status} />
      </div>
    ))}
  </div>
);

export default function Tasks() {
  const { data, error, loading, reload } = useResource("/tasks");
  return (
    <div>
      <PageHeader eyebrow="Development · Records" title="Development Tasks" />
      <Panel title="Record a task" className="mb-6"><NewTask onDone={reload} /><p className="mt-3 text-xs text-[var(--cc-muted)]">Tasks are governance records only. Nothing is executed in Phase 1.</p></Panel>
      <Panel title="Task ledger" testId="task-ledger">{loading ? <Loading /> : error ? <ErrorNote error={error} /> : <TaskList tasks={data} />}</Panel>
    </div>
  );
}
